import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { DepositService } from '../../../../service/deposit.service';

@Component({
    selector: 'app-password-block',
    templateUrl: 'password-block.component.html',
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatTooltip, TranslateModule],
})
export class PasswordBlockComponent {
    private depositService = inject(DepositService);

    passwordBlockFormGroup: FormGroup;
    payerPassword: string;

    constructor() {
        this.passwordBlockFormGroup = new FormGroup({
            payerPassword: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(32)]),
        });
    }

    onPasswordChange() {
        this.depositService.depositInfo.paymentAccountInfo.payerPassword = this.payerPassword;
    }
}
